import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'dialog-window',
    templateUrl: 'dialog.component.html',
    styleUrls: ['dialog.component.css']
})
/**
 * Каркас диалогового окна
 * @example <dialog-window [title]="title" (close)="close()" [modal]="true" [focusOnCloseButton]="true" [full-height]="false"> YOUR HTML  
                <div dialog-footer class="handler-buttons">
                    <button (click)="onOk()" class="blue-button">OK</button>&nbsp;
                    <button (click)="close()" class="blue-button">Отмена</button>
                </div>
            </dialog-window>
 */
export class DialogComponent implements OnInit, OnDestroy, AfterViewInit {
    /**
     * Количество открытых окон
     */
    static counter:number = 0;
    /**
     * Заголовок окна
     */
    @Input("title") title = "Заголовок";
    /**
     * Является ли окно модальным.
     */
    @Input("modal") modal:boolean = false;
    /**
     * Установка фокуса на кнопке закрытия окна
     */
    @Input("focusOnCloseButton") focusOnCloseButton:boolean = false;
    /**
    * Использовать всю высоту окна, без padding
    */
    @Input("full-height") fullHeight:boolean = false;
    /**
     * Нажатие кнопки закрыть в заголовке окна
     */
    @Output("close") onClose:EventEmitter<null> = new EventEmitter();   
    /**
     * HTMLElement кнопки закрытия окна
     */
    @ViewChild("closeButton") closeButton:ElementRef = null;
    /**
     * Отступ окна в процентах
     */
    margin:number = 0;
    /**
     * Анимация появления окна
     */
    show_animation:boolean = true;
    constructor() {
    }
    
    ngOnInit() { 
        this.margin = DialogComponent.counter * 3;
        this.fullHeight ? null : DialogComponent.counter++;
    } 
    ngOnDestroy() { 
        this.fullHeight ? null : DialogComponent.counter--;
        this.onClose.complete();
        this.onClose.unsubscribe();
     } 
    ngAfterViewInit() {
        if(this.focusOnCloseButton && this.closeButton && this.closeButton.nativeElement){
            this.closeButton.nativeElement.focus();
        }
        setTimeout(() => {
            this.show_animation = false;
        }, 100);
    }
    /**
     * Закрытие диалогового окна
     */
    close(){
        this.onClose.emit(null);
    }
    /**
     * Закрытие окна по клику на background диалогового окна
     * @param e Событие MouseEvent
     */
    bgClose(e:MouseEvent){
        if(!this.modal && (e.target == e.currentTarget)){
            this.close();
        }
    }
}